<template>
  <div id="footer" class="container-fluid">
    <p class="address_tel_fax">
      <span>地址：北京市昌平区回龙观镇龙域中心B座11层1101室</span>
    </p>
    <p class="address_tel_fax">
      <span>Tel：010-82967579</span>
    </p>
    <p class="email_wx">
      <span>邮箱：liyanfang@tigecom.com</span>
    </p>
    <p class="email_wx"><span>icp备案号：<a href="https://beian.miit.gov.cn/">京ICP备2022015206号</a></span></p>
    <p class="copy">
      Copyright &copy; 2018 - 2026 北京泰格青川网络技术有限公司
    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.address_tel_fax:first-child {
  margin-top: 50px;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue